import { render, staticRenderFns } from "./upgrade_warning_box.vue?vue&type=template&id=09ec3c7e"
import script from "./upgrade_warning_box.vue?vue&type=script&lang=js"
export * from "./upgrade_warning_box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports